<template>
  <div class="month-report-bottom">
    <div class="month-report-bottom-inner">
      <!-- Bottom right month report -->
      <template v-for="(result,index) in forecastResult">
        <div class="each-month each-moth-bottom bottom-alloc-gutters" :key="index">
          <div class="month-table">
            <result-row :result="result.internal"></result-row>
            <result-row :result="result.external"></result-row>
            <result-row :result="result.total"></result-row>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const ResultRow = () => import("./ResultRow");

export default {
  name: "Result",
  components: { ResultRow },
  computed: {
    forecastResult: function() {
      return this.$store.state.forecast.result;
    }
  }
};
</script>

<style scoped>
</style>
